// extracted by mini-css-extract-plugin
export var currentStep = "_gn-2";
export var nodeCard = "_gn-0";
export var pathHighlighted = "_gn-1";